import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserUpgradesAsync } from './AddonsAndUpgradesBlockAsyncThunk';


const initialState = {
    worldType: '', //cellular|abroad|internet|tv|energy
    title: '',
    userUpgradesTabTitle: '',
    userAddonsTabTitle: '',
    maxServicesToDisplay: '',
    isFinishLoading: false,
    userUpgrades: [],
    userAddons: [],
    removedSocList: [],
    hboStatus: null,
    disneyStatus: null,
};

const addonsAndUpgradesBlockSlice = createSlice({
    name: 'addonsAndUpgradesBlock',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                state.worldType = action.payload.worldType;
                state.title = action.payload.title;
                state.userUpgradesTabTitle = action.payload.userUpgradesTabTitle;
                state.userAddonsTabTitle = action.payload.userAddonsTabTitle;
                state.maxServicesToDisplay = action.payload.maxServicesToDisplay;
            },
            prepare: (action) => {
                const currentBlock = action.currentBlock;
                const worldType = getWorldType(currentBlock.worldType?.value);
                const title = currentBlock.title?.value;
                const userUpgradesTabTitle = currentBlock.userUpgradesTabTitle?.value;
                const userAddonsTabTitle = currentBlock.userAddonsTabTitle?.value;
                const maxServicesToDisplay = currentBlock.maxServicesToDisplay?.value;

                let payload = {
                    worldType: worldType,
                    title: title,
                    userUpgradesTabTitle: userUpgradesTabTitle,
                    userAddonsTabTitle: userAddonsTabTitle,
                    maxServicesToDisplay: maxServicesToDisplay,
                };
                return { payload: payload };
            }
        },
        resetData: (state, action) => {
            state.isFinishLoading = false;
            state.userUpgrades = [];
            state.userAddons = [];
        },
        setRemoveSoc: (state, action) => {
            state.removedSocList.push(action.payload);
        },
        reportDWH: (state, action) => { },
    },
    extraReducers: {
        [getUserUpgradesAsync.fulfilled]: (state, action) => {
            if (!action.payload) {
                state.isFinishLoading = true;
                return;
            }

            if (state.worldType != action.payload.worldType) { return; }

            state.isFinishLoading = true;
            if (!action.payload || !action.payload.successCatalogResult?.isSuccess) {
                state.userUpgrades = [];
                state.userAddons = [];
                return;
            }
            state.userUpgrades = action.payload.saleCatalogByAction.addingListCatalog, state;
            state.userAddons = getAllServices(action.payload.saleCatalogByAction.existingListCatalog/*, action.payload.ban, state*/);
            state.hboStatus = action.payload.saleCatalogByAction?.hboStatus ?? null;
            state.disneyStatus = action.payload.saleCatalogByAction?.disneyStatus ?? null;
        },
    },
});


function getWorldType(worldType) {
    if (!worldType) { return ''; }
    switch (worldType) {
        case 1: return 'cellular';
        case 2: return 'abroad';
        case 3: return 'internet';
        case 4: return 'tv';
        case 5: return 'energy';
        default: return '';
    }
}


function getAllServices(serviceList/*, ban, state*/) {
    if (!serviceList || serviceList.length == 0) { return []; }
    let allServices = [];

    //serviceList[0].count = 3;
    //const socListToRemove = state.removedSocList;

    serviceList?.map(function (item) {
        //const soc = socListToRemove.find(x => x.name == item.name && x.ban == ban);
        //if (soc) { return; }

        if (item.count > 1) {
            const copies = Array(item.count).fill(item);
            allServices = allServices.concat(copies);
        }
        else {
            allServices.push(item);
        }
    });

    return allServices;
}


export const {
    resetBlock,
    initBlock,
    resetData,
    setRemoveSoc,
    reportDWH
} = addonsAndUpgradesBlockSlice.actions;

export default addonsAndUpgradesBlockSlice.reducer;

